import { FeesErrorDescription } from "@redotech/redo-storefront-common/config/errors";
export enum CoverageNotShowingReason {
  BLOCK_REDO = "BLOCK_REDO",
  FEES_ERROR = "FEES_ERROR",
  TERMS_NOT_ACCEPTED = "TERMS_NOT_ACCEPTED",
  NO_ENABLED_INTEGRATION = "NO_ENABLED_INTEGRATION",
  MISSING_COVERAGE_PRICE = "MISSING_COVERAGE_PRICE",
  SHOPPER_NOT_ELIGIBLE = "SHOPPER_NOT_ELIGIBLE",
  ALL_COVERAGE_DISABLED = "ALL_COVERAGE_DISABLED",
  COVERAGE_PAUSED = "COVERAGE_PAUSED",
  NO_TOGGLE_LOCATIONS_FOUND = "NO_TOGGLE_LOCATIONS_FOUND",
  CART_NOT_ELIGIBLE = "CART_NOT_ELIGIBLE",
  CART_EMPTY = "CART_EMPTY",
  REDO_PRODUCTS_ERROR = "REDO_PRODUCTS_ERROR",
  INSUFFICIENT_PLATFORM_PERMISSIONS = "INSUFFICIENT_PLATFORM_PERMISSIONS",
  MERCHANT_HID_REDO = "MERCHANT_HID_REDO",
  CHECKOUT_ONLY_STRATEGY = "CHECKOUT_ONLY_STRATEGY",
  NONE_STRATEGY = "NONE_STRATEGY",
  ALL_SEEMS_OK = "ALL_SEEMS_OK",
  UNKNOWN = "UNKNOWN",
  MERCHANT_PAID = "MERCHANT_PAID",
  PRODUCT_LOCKED = "PRODUCT_LOCKED",
  MERCHANT_BILLING_INFO_INCOMPLETE = "MERCHANT_BILLING_INFO_INCOMPLETE",
  STOREFRONT_PUBLISH_STATUS = "STOREFRONT_PUBLISH_STATUS",
  SFCC_SITE_ID_MISSING = "SFCC_SITE_ID_MISSING",
  SFCC_FEE_CONTROLLER_MISSING = "SFCC_FEE_CONTROLLER_MISSING",
  SFCC_CARTRIDGE_NOT_LOADED = "SFCC_CARTRIDGE_NOT_LOADED",
  SFCC_CARTRIDGE_FEE_DISABLED = "SFCC_CARTRIDGE_FEE_DISABLED",
  MIVA_STORE_CODE_MISSING = "MIVA_STORE_CODE_MISSING",
}

export const feesErrorToCoverageNotShowingReason: Record<
  FeesErrorDescription,
  CoverageNotShowingReason
> = {
  [FeesErrorDescription.ONBOARDING_NOT_FINISHED]:
    CoverageNotShowingReason.FEES_ERROR,
  [FeesErrorDescription.TERMS_NOT_ACCEPTED]:
    CoverageNotShowingReason.TERMS_NOT_ACCEPTED,
  [FeesErrorDescription.NO_ENABLED_INTEGRATION]:
    CoverageNotShowingReason.NO_ENABLED_INTEGRATION,
  [FeesErrorDescription.SHOP_DISABLED_COVERAGE]:
    CoverageNotShowingReason.ALL_COVERAGE_DISABLED,
  [FeesErrorDescription.STORE_HAS_MISCONFIGURED_ONBOARDING]:
    CoverageNotShowingReason.MISSING_COVERAGE_PRICE,
  [FeesErrorDescription.INSUFFICIENT_PERMISSIONS_TO_ACCESS_ECOMMERCE_PLATFORM_RESOURCES]:
    CoverageNotShowingReason.INSUFFICIENT_PLATFORM_PERMISSIONS,
  [FeesErrorDescription.THROTTLED]: CoverageNotShowingReason.FEES_ERROR,
  [FeesErrorDescription.PRODUCT_LOCKED]:
    CoverageNotShowingReason.PRODUCT_LOCKED,
};

export const OPEN_SEQUENCE = "redodebug" as const;
